// extracted by mini-css-extract-plugin
export default {"invoiceSummary":"invoiceSummary_invoiceSummary__Fpitp","label":"invoiceSummary_label__lq4SQ"};